import { render, staticRenderFns } from "./AgendaShowAppointment.vue?vue&type=template&id=33faaf12"
import script from "./AgendaShowAppointment.vue?vue&type=script&lang=js"
export * from "./AgendaShowAppointment.vue?vue&type=script&lang=js"
import style0 from "./AgendaShowAppointment.vue?vue&type=style&index=0&id=33faaf12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports